export * from './components';
export * from './context';
export * from './hooks';
export * from './manager';
export * from './models';
export * from './player';
export * from './util';
export * from './types';
export * from './api/types';
export * from './generic';
export * from './translations';
window.getStickyAndHeaderHeight = function () {
    var _a, _b;
    var sticky = ((_a = document.getElementsByClassName('sticky').item(0)) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
    var header = ((_b = document.getElementsByClassName('HeaderBar').item(0)) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0;
    return header + sticky;
};
Array.prototype.chunk = function (chunkSize) {
    var R = new Array();
    for (var i = 0; i < this.length; i += chunkSize)
        R.push(this.slice(i, i + chunkSize));
    return R;
};
Array.prototype.includesLowercase = function (str) {
    if (typeof str !== 'string') {
        return this.includes(str);
    }
    return this.map(function (t) { return t.toLowerCase(); }).includes(str.toLowerCase());
};
Array.prototype.unique = function (property) {
    var s = new Set();
    return this.filter(function (value, index, self) {
        if (property && s.has(value[property])) {
            return false;
        }
        else if (property) {
            s.add(value[property]);
            return true;
        }
        if (s.has(value)) {
            return false;
        }
        s.add(value);
        return true;
    });
};
//# sourceMappingURL=index.js.map